import { Box, Flex } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';
import LocationList from './LocationList';

function Locations() {
  return (
    <Flex height="100%" gap="20px">
      <LocationList w="30%" />
      <Box flex={1}>
        <Outlet />
      </Box>
    </Flex>
  );
}

export default Locations;
